<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>
          {{ 'Purchase_Order_Title' | translateWF: 'Purchase Orders' }}
        </h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-speeddial [model]="orderMenuItems()" direction="left" [transitionDelay]="80">
              <ng-template #button let-toggleCallback="toggleCallback">
                <p-button (click)="toggleCallback($event)" [label]="'Purchase_Order_Create_Order' | translateWF: 'Create Order'" icon="pi pi-plus" iconPos="left"></p-button>
              </ng-template>
              <ng-template #item let-item let-toggleCallback="toggleCallback">
                <p-button severity="secondary" (click)="toggleCallback($event, item)" [label]="item.label | translateWF: item.label"></p-button>
              </ng-template>
            </p-speeddial>
          }
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'Purchase_Order_Title' | translateWF: 'Purchase Orders'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="listPurchaseOrders()" [lazy]="true" [sortField]="sortField()" [sortOrder]="sortOrder()" selectionMode="single" (onSort)="onSort($event)">
            <ng-template pTemplate="header">
              <tr class="cs-datatable-header-dark">
                <th pSortableColumn="purchaseOrderNumber">
                  {{ 'Purchase_Order_PO_Number' | translateWF: 'PO Number' }}
                  <p-sortIcon field="purchaseOrderNumber"></p-sortIcon>
                </th>
                <th>{{ 'Purchase_Order_Type' | translateWF: 'Type' }}</th>
                <th>{{ 'Purchase_Order_Date_Created' | translateWF: 'Date Created' }}</th>
                <th>{{ 'Purchase_Order_Status' | translateWF: 'Status' }}</th>
                <th>{{ 'Purchase_Order_Provider' | translateWF: 'Provider' }}</th>
                <th>{{ 'Purchase_Order_Items' | translateWF: 'Items' }}</th>
                <th>{{ 'Purchase_Order_ShippingTo' | translateWF: 'Shipping To' }}</th>
                <th>{{ 'Purchase_Order_BillingTo' | translateWF: 'Billing To' }}</th>
                <th></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-index="rowIndex">
              @let po = getRowData(rowData);
              <tr class="cursor-pointer" (click)="redirectToDetails(po.id)">
                <td>
                  <a>{{ po.purchaseOrderNumber }}</a>
                </td>
                <td>{{ orderTypes()[po.type] || '-' }}</td>
                <td>{{ po.createdDate | date: 'dd/MM/yyyy' }}</td>
                <td>{{ statuses()[po.status] }}</td>
                <td>{{ getSpecificProvider(po.providerReference) }}</td>
                <td>
                  @if (po.items && po.items.length > 0) {
                    @for (item of po.items; track item.itemCode; let isLast = $last) {
                      @if (item.item?.itemDisplayName) {
                        <span
                          >({{ item.itemCode }}) {{ item.item?.itemDisplayName | localized }}
                          @if (!isLast) {
                            <span>, </span>
                          }
                        </span>
                      }
                    }
                  }
                </td>
                <td>{{ getSpecificShippingTo(po.shipToReference) }}</td>
                <td>{{ getSpecificBillTo(po.billToReference) }}</td>
                <td>
                  @if (canPrintReport(po)) {
                    <p-button severity="secondary" icon="pi pi-print" (click)="printReportPdf(po.id); $event.stopPropagation()"></p-button>
                  }
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="9">
                  {{ 'Purchase_Order_No_Orders_Found' | translateWF: 'No purchase orders found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[15, 25, 50, 100]"
            dropdownAppendTo="body"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
